export enum ErrorStatusCodes {
	NetworkError = 0,
	Ok = 200,
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
	InternalServerError = 500,
	PayloadTooLarge = 413,
}